module.exports = __webpack_public_path__ + "img/pcn-info.a731a577.svg";